// The Spur Monocle assessment for this page (see app/views/shared/_monocle.html.erb), sent with a logged-out
// customer create so the server can tell whether this session comes through a proxy. Monocle usually answers
// at once but takes longer when it suspects a proxy, so a submit waits a little for it. Resolves with the
// encrypted assessment, or null when Monocle isn't on the page or hasn't answered in time.
export default function monocleAssessment(timeoutMs = 3000) {
  const latest = () => window.wiqMonocleAssessment || null;
  if (!document.getElementById('_mcl')) {
    return Promise.resolve(null);
  }

  const startedAt = Date.now();
  return new Promise((resolve) => {
    const check = () => {
      const assessment = latest();
      if (assessment || Date.now() - startedAt >= timeoutMs) {
        resolve(assessment);
      } else {
        setTimeout(check, 100);
      }
    };
    check();
  });
}
